import type { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface KpiCardProps {
  title: ReactNode;
  value: ReactNode;
  secondary?: ReactNode;
  /** 'default' | 'success' | 'destructive' | 'warning' */
  valueVariant?: 'default' | 'success' | 'destructive' | 'warning';
  'data-testid'?: string;
}

const variantClass: Record<string, string> = {
  default: 'text-foreground',
  success: 'text-success',
  destructive: 'text-destructive',
  warning: 'text-warning',
};

/**
 * Single KPI card. Purely presentational — page-level test covers integration.
 */
export function KpiCard({
  title,
  value,
  secondary,
  valueVariant = 'default',
  'data-testid': testId,
}: KpiCardProps) {
  return (
    <Card data-testid={testId}>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className={cn('text-2xl font-bold tabular-nums', variantClass[valueVariant])}>
          {value}
        </div>
        {secondary ? <p className="mt-1 text-xs text-muted-foreground">{secondary}</p> : null}
      </CardContent>
    </Card>
  );
}
